// Per-cell dimensions of the source sprite sheet. These describe the sheet
// itself — not how cards get rendered on the page. For the display default,
// see DEFAULT_TILE_WIDTH / DEFAULT_TILE_HEIGHT in Tile.js.
export const SPRITE_CELL_WIDTH = 71;
export const SPRITE_CELL_HEIGHT = 96;
export const SPRITE_COLS = 13;
export const SPRITE_ROWS = 6;
export const SPRITE_SHEET_URL = "/solitaire-images-full.png";

const SUITS = ["spade", "heart", "club", "diamond"];
const RANKS = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];

function buildTiles() {
  const tiles = {};
  SUITS.forEach((suit, row) => {
    RANKS.forEach((rank, col) => {
      tiles[`${suit}-${rank}`] = [row, col];
    });
  });
  for (let i = 0; i < 10; i++) tiles[`back-${i}`] = [4, i];
  for (let i = 0; i < 9; i++) tiles[`back-${10 + i}`] = [5, i];
  tiles.recycle = [4, 10];
  tiles["big-x"] = [4, 11];
  tiles.foundation = [4, 12];
  return tiles;
}

export const TILES = buildTiles();

// The full set of card-back sprite keys (back-0 .. back-18). Used by
// SpectatedSolitaire to give each neighbor a different back, and by the
// `?back=N` player override in App.
export const CARD_BACKS = Array.from({ length: 19 }, (_, i) => `back-${i}`);
